/*! GroupInViewportRefreshStrategy */

import Ad from "../gpt/Ad";
import Viewability from "../viewability/Viewability";

/**
 * Provides a strategy to refresh ads grouped by
 * CompanionGroup relationships, constrained
 * by all members of the group being in viewport.
 */
export default class GroupInViewportRefreshStrategy {

    /**
     * @constructs GroupInViewportRefreshStrategy
     */
    _viewability: Viewability;
    constructor(viewability: Viewability) {
        this._viewability = viewability;
    }

    /**
     * Determines which ads to refresh. Ungrouped ads
     * are always returned, and grouped ads are checked
     * to be in viewport.
     */
    wouldRefresh(ads: Ad[]): Ad[] {
        const ungroupedAds = ads.filter((ad) => (ad.isDisplayable() && ad.companionGroup() === null));

        const groupParents = ads.filter((ad) =>
            // exclude ads that are children, we only need to
            // run the refresh checks starting from one ad
            // in the group of ads. We consider that one to be
            // the "parent"
            (ad.isDisplayable() && ad.companionGroup() !== null && !ad.isCompanionChild()));

        return this.entirelyViewableGroups(groupParents).concat(ungroupedAds);
    }

    /**
     * Returns ads in a CompanionGroup in all are viewable
     *
     */
    private entirelyViewableGroups(groupParents: Ad[]): Ad[] {
        return groupParents.reduce((refreshableAds, parentAd) => {

            const parentAdCompanionGroup = parentAd.companionGroup();

            if (!parentAdCompanionGroup) return [];

            const pendingAds = parentAdCompanionGroup.members();

            if (this._viewability.everyViewable(pendingAds)) {
                return refreshableAds.concat(pendingAds);
            }

            return refreshableAds;
        }, [] as Ad[]);
    }

}
